import { HttpInterceptorFn } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SKIP_AUTH } from '@shared/auth';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

export const ServerErrorInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_AUTH)) {
    return next(req);
  }

  const toastr = inject(ToastrService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 400) {
        // server sends user displayable error messages as a 400 error
        return next(req);
      }
      if (error.status === 401) {
        // cannot logout & return EMPTY as stocktake service getStocktake() returns 401 for board auth required
        toastr.error('Try logging out and in again', '401 Unauthenticated');
        return next(req);
      }
      if ((error.status === 504 || error.status === 0) && error.url?.includes('data-validity/gaps/index/live')) {
        // this page might legitimately time out, so 504s are caught/handled by the component
        return next(req);
      }
      if (error.status === 403) {
        toastr.error('Try again or contact support', 'Permission denied');
      }
      return throwError(() => error);
    })
  );
};
